import React, { useEffect, useState } from "react";
import "./dashboard.css";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { logMessage, signOutUser } from "../../utils/helpers.js";
import { TbCircleKey } from "react-icons/tb";
import { GoShieldCheck } from "react-icons/go";
import Header from "../../components/common/header.js";
import imagePaths from "../../assets/imagePaths.js";
import YourProgressPanel from "./components/YourProgressPanel.js";
import PointsDashboardPanel from "./components/PointsDashboardPanel.js";
import LevelJourneyPanel from "./components/LevelJourneyPanel.js";
import paths from "../../utils/constants.js";
import api from "../../api/api.js";
import { ApiResponse } from "../../models/ApiResponseModel.js";
import { HiOutlineClipboardDocumentCheck } from "react-icons/hi2";
import { FiUserX } from "react-icons/fi";
import { MdKeyboardArrowRight, MdOutlinePlaylistAddCheckCircle, } from "react-icons/md";
import { FaCamera, FaEye, FaEyeSlash } from "react-icons/fa";
import { IoIosWarning } from "react-icons/io";
import { UserData } from "../../models/UserModel.js";
import { SubModel } from "../../models/SubscriptionModel.js";
import StreaksJourneyPanel from "./components/StreaksJourneyPanel.js";
import BadgesPanel from "./components/BadgesPanel.js";
import RewardsPanel from "./components/RewardsPanel.js";
import RewardDetailPanel from "./components/RewardDetailPanel.js";

const styles = {
  otpContainer: {
    display: 'flex',
    gap: '10px',
    justifyContent: 'center',
    margin: '15px 0 15px 0',
  },
  otpInput: {
    width: '65px',
    height: '25px',
    fontSize: '20px',
    textAlign: 'center',
    backgroundColor:'#fff',
    border: '1px solid #552F83',
    borderRadius: '4px',
    outline: 'none',
    transition: 'border-color 0.2s',
  },
};

const MyProfile = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [type, setType] = useState("personal");
  const [showPopup, setShowPopup] = useState(false);
  const [isVip, setIsVip] = useState("false");
  const [showSubPopUp, setShowSubPopUp] = useState(false);
  const [showIosPopUp, setShowIosPopUp] = useState(false);
  const [currencySymbol, setCurrencySymbol] = useState("$");
  const [subscriptionPurchasedFrom, setSubscriptionPurchasedFrom] = useState("");
  const [name, setName] = useState();
  const [showVerifyPopUp, setShowVerifyPopUp] = useState(false);
  const [imageChange, setImageChange] = useState(false);
  const [subId, setSubId] = useState("");
  const [userType, setUserType] = useState("");
  const [purchasedOn, setPurchasedOn] = useState("");
  const [expiryTime, setExpiryTime] = useState("");
  const [buttonLoading, showButtonLoading] = useState(false);
  const [interval, setInterval] = useState("");
  const [status, setStatus] = useState("");
  const [intervalCount, setIntervalCount] = useState("");
  const [currency, setCurrency] = useState("");
  const [amount, setAmount] = useState("");
  const [renewalAmount, setRenewalAmount] = useState("");
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [email, setEmail] = useState(localStorage.getItem("user_email"));
  const [profile, setProfile] = useState();
  const [progressData, setProgressData] = useState(null);

  const isProgressLayout =
    location.pathname === paths.YOUR_PROGRESS ||
    location.pathname === paths.POINTS_DASHBOARD ||
    location.pathname === paths.LEVEL_JOURNEY ||
    location.pathname === paths.STREAKS_JOURNEY || 
    location.pathname === paths.BADGES_PANEL ||
    location.pathname === paths.REWARD_PANEL;
  const isProgressPage = location.pathname === paths.YOUR_PROGRESS;
  const isPointsDashboardPage = location.pathname === paths.POINTS_DASHBOARD;
  const isLevelJourneyPage = location.pathname === paths.LEVEL_JOURNEY;
  const isStreaksJourneyPage = location.pathname === paths.STREAKS_JOURNEY;
  const isBadgesPanelPage = location.pathname === paths.BADGES_PANEL;
  const isRewardPanelPage = location.pathname === paths.REWARD_PANEL;
  const isRewardDetailPage = location.pathname === paths.REWARD_DETAIL;
  const [userData, setUserData] = useState({
    old_password: "",
    new_password: "",
    confirmpassword: "",
  });

  const [supportData, setsupportData] = useState({
    name: localStorage.getItem("user_name") || "",
    email:localStorage.getItem("user_email") || "",
    subject: "",
    comments: "",
  });

  const [editFormData, setEditFormData] = useState({
    name: "",
    image: "",
  });

  const togglePopup = () => {
    logMessage("toggleclicked");
    setShowPopup(!showPopup);
    logMessage(showPopup);
  };

  const toggleIosPopup = () => {
    logMessage("toggleclicked");
    setShowIosPopUp(!showIosPopUp);
    logMessage(showPopup);
  };

  const toggleNewPasswordVisibility = (passwordType) => {
    if (passwordType == "current") {
      setShowCurrentPassword(!showCurrentPassword);
    } else if (passwordType == "new") {
      setShowNewPassword(!showNewPassword);
    } else {
      setShowConfirmPassword(!showConfirmPassword);
    }
  };
  useEffect(() => {
    
    const params = new URLSearchParams(location.search);
    const isViewPlans = params.get("viewplans") === "true";

    if (isViewPlans) {
      openSubscribeBox();
    }
    
  }, [location.search])

  const openSubscribeBox = () => {
    const sortButton = document.getElementById('showMainSubBox');
    if (sortButton) {
      sortButton.click();
    }
  };
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const viewPlanParam = searchParams.get("viewplan");

    if (viewPlanParam === "true") {
      const sortButton = document.getElementById('showMainSubBox');
      if (sortButton) {
        sortButton.click();
      }
    }
  }, [location.search]);

  const Option = ({ calling, label, icon: Icon }) => {
    return (
      <div onClick={() => optionClick(calling)} className="settings-option">
        <div className="setting_labeled">
          <span className="icon_class">{Icon}</span>
          <span>{label}</span>
        </div>
        <span className="settings-option-arrow">›</span>
      </div>
    );
  };
  const refreshPage = () => {
    window.location.reload();
  };
  const handleChange = (typeSet) => {
    setType(typeSet);
  };

  const optionClick = (calling) => {
    switch (calling) {
      case "changePassword":
        setType("change_password");
        break;
      case "terms":
        // navigate(paths.TERMS);
        window.open(paths.TERMS, "_blank");
        break;
      case "privacy":
        // navigate(paths.PRIVACY);
        window.open(paths.PRIVACY, "_blank");
        break;
      case "support":
        // navigate(paths.PRIVACY);
        setType("support");
        break;
        // window.open("mailto:support@dreamerdesigns.com", "_blank");
        break;
      // case "about":
      //   // navigate(paths.ABOUTUS);
      //   window.open(paths.ABOUTUS, '_blank');
      //   break;
      case "delete":
        togglePopup();
        break;
      default:
        break;
    }
  };

  const handleNameChange = (event) => {
    setName(event.target.value);
    setEditFormData((prevFormData) => ({
      ...prevFormData,
      name: event.target.value,
    }));
  };

  const handleFormChange = (event) => {
    const { name, value } = event.target;
    setUserData((prevUserData) => ({
      ...prevUserData,
      [name]: value,
    }));
  };
const handleSupportFormChange = (event) => {
    const { name, value } = event.target;
    setsupportData((prevUserData) => ({
      ...prevUserData,
      [name]: value,
    }));
  };
  const getTypeComponent = (type) => {
    const components = {
      personal: () => renderPersonalInfo(),
      settings: () => renderSettingsOptions(),
      change_password: () => changePasswordInfo(),
      support: () => supportInfo(),
      // Add more types and corresponding rendering options here
    };

    const component = components[type];
    if (!component) {
      console.error(`Invalid type: ${type}`);
      return null;
    }

    return component();
  };

  const handleEditProfile = async (event) => {
    logMessage(editFormData);
    event.preventDefault();
    startLoading();
    try {
      const response = await api.editProfile(editFormData, imageChange);
      const apiResponse = new ApiResponse(response.status, response.message);
      if (apiResponse.status == 1) {
        // stopLoading();
        setTimeout(() => {
          getProfileData();
        }, 1000);
      } else {
        // console.log("here");
        logMessage(apiResponse.message, "alert");
      }
    } catch (error) {
      logMessage(error);
    } finally {
      // stopLoading();
    }
  };

  const handleChangePassword = async (event) => {
    logMessage(editFormData);
    event.preventDefault();
    if (userData.confirmpassword != userData.new_password) {
      logMessage("Your confirm password mismatches with new password", "alert");
    } else {
      try {
        startLoading();
        const response = await api.changePassword(userData);
        const apiResponse = new ApiResponse(response.status, response.message);
        if (apiResponse.status == 1) {
          stopLoading();
          setUserData({
            old_password: "",
            new_password: "",
            confirmpassword: "",
          });
          setType("settings");
        } else {
          logMessage(apiResponse.message, "alert");
        }
      } catch (error) {
        logMessage(error);
      } finally {
        stopLoading();
      }
    }
  };

  const handleSendSupport = async (event) => {
    event.preventDefault();
      try {
        startLoading();
        console.log(supportData);
        const response = await api.sendSupportEmail(supportData);
        const apiResponse = new ApiResponse(response.status, response.message);
        if (apiResponse.status == 1) {
          stopLoading();
          setsupportData({
            name: "",
            email: "",
            subject: "",
            comments: "",
          });
          logMessage(apiResponse.message, "email_alert");
        } else {
          logMessage(apiResponse.message, "alert");
        }
      } catch (error) {
        logMessage(error);
      } finally {
        stopLoading();
      }
  };

  const renderPersonalInfo = () => (
    <div className="personal_info">
      <form onSubmit={handleEditProfile}>
        <div className="form_container personal_form">
          <div className="form_fields">
            <label>Name:</label>
            <input
              type="text"
              name="design"
              onChange={handleNameChange}
              value={editFormData.name}
            />
          </div>
          <div className="form_fields">
            <label>Email:</label>
            <input
              type="text"
              style={{ color: "#808080" }}
              name="email"
              defaultValue={email}
              readOnly
            />
          </div>
        </div>
        <div className="button_fields">
          <button className="addProject" type="submit">
            Update
          </button>
        </div>
      </form>
    </div>
  );

  const changePasswordInfo = () => (
    <div className="personal_info changePassword">
      <p className="settingspassword">Settings {">"} Change password</p>
      <form onSubmit={handleChangePassword}>
        <div className="form_container personal_form">
          <div className="form_fields currentpassword">
            <label>Current password:</label>
            {/* <div> */}
            <input
              type={showCurrentPassword ? "text" : "password"}
              placeholder="Password"
              name="old_password"
              value={userData.old_password}
              onChange={handleFormChange}
              required
            />
            <button
              className="passwordEye"
              type="button"
              onClick={() => toggleNewPasswordVisibility("current")}
            >
              {showCurrentPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
            {/* </div> */}
          </div>
          <div className="form_fields">
            <label>New password:</label>
            <input
              type={showNewPassword ? "text" : "password"}
              placeholder="New"
              name="new_password"
              value={userData.new_password}
              onChange={handleFormChange}
              required
            />
            <button
              className="passwordEye"
              type="button"
              onClick={() => toggleNewPasswordVisibility("new")}
            >
              {showNewPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
          <div className="form_fields">
            <label>Confirm password:</label>
            <input
              type={showConfirmPassword ? "text" : "password"}
              placeholder="Confirm"
              name="confirmpassword"
              value={userData.confirmpassword}
              onChange={handleFormChange}
              required
            />
            <button
              className="passwordEye"
              type="button"
              onClick={() => toggleNewPasswordVisibility("confirm")}
            >
              {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
        </div>
        <div className="button_fields">
          <button className="addProject changeProfilePassword" type="submit">
            Change
          </button>
        </div>
      </form>
    </div>
  );
  const supportInfo = () => (
    <div className="personal_info changePassword">
      {/* <p className="settingspassword">Settings {">"} Support</p> */}
      <form onSubmit={handleSendSupport} className="supportForm">
        <div style={{width:"100%"}} className="support_form">
          <img 
          style={{
            width:"200px"
          }}
          src={imagePaths.supportImage}></img>
          <p className="messageSupport">If you're facing an issue, don't worry—we're here to help! Share the details below, and we’ll take care of the rest.</p>
          <div style={{width:"100%"}} className="form_fields">
            <p className="supportLabel" style={{width:"70px", textAlign:"right"}} >Subject:</p>
            <input
             type="text"
              placeholder="Enter a title"
              name="subject"
              value={supportData.subject}
              onChange={handleSupportFormChange}
              required
            />
         
          </div>
          <div style={{width:"100%"}} className="form_fields">
            <p className="supportLabel" style={{width:"70px", textAlign:"right"}}>Comments:</p>
            <textarea
                className="commentsTextArea"
                placeholder="Describe the issue"
                style={{
                  height: "80px",
                  lineHeight: "normal",
                  padding: "5px",
                  resize: "none",
                  width: "100%",
                  boxSizing: "border-box",
                }}
                name="comments"
                value={supportData.comments}
                onChange={handleSupportFormChange}
                required
              />
          </div>
        </div>
        <div className="button_fields">
          <button className="addProject changeProfilePassword" type="submit">
            Send
          </button>
        </div>
      </form>
    </div>
  );
  const renderSettingsOptions = () => (
    <div className="settings_options">
      <Option
        calling="changePassword"
        label="Change Password"
        icon={<TbCircleKey />}
      />
      <Option calling="support" label="Support" icon={<GoShieldCheck />} />
      {/* <Option
        calling="about"
        label="About"
        icon={<IoIosInformationCircleOutline />}
      /> */}
      <Option
        calling="terms"
        label="Terms & Conditions"
        icon={<MdOutlinePlaylistAddCheckCircle />}
      />
      <Option
        calling="privacy"
        label="Privacy Policy"
        icon={<HiOutlineClipboardDocumentCheck />}
      />
      <Option calling="delete" label="Delete Account" icon={<FiUserX />} />
    </div>
  );

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImageChange(true);
      const reader = new FileReader();
      reader.onload = (e) => {
        setEditFormData((prevFormData) => ({
          ...prevFormData,
          // image: [...prevFormData.image, e.target.result]
          image: file,
        }));
        setProfile(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };
  const deleteAccount = async () => {
    try {
      startLoading();
      const response = await api.deleteAccount();
      const apiResponse = new ApiResponse(response.status, response.message);
      if (apiResponse.status === 1) {
        signOutUser(navigate);
      } else {
        logMessage(apiResponse.message, "alert");
      }
    } catch (error) {
      logMessage(error);
    } finally {
      stopLoading();
    }
  };
  //============================ Cancel Subscription =================================
  // const [otp, setOtp] = React.useState(0);
  const [otp, setOtp] = useState(['', '', '', '']);


  // Handle input change for each field
  const handleChangeCancel = (e, index) => {
    const value = e.target.value;
    if (/^[0-9]$/.test(value) || value === '') {  // Only allow single digit numbers
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Move focus to the next input if a digit is entered
      if (value && index < otp.length - 1) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }
    }
  };

  // Handle backspace for navigating to previous input
  const handleBackspace = (e, index) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      document.getElementById(`otp-input-${index - 1}`).focus();
    }
  };

  const [finalCancelConfirm, setFinalCancelConfirm] = React.useState(false);
  const [showOtpView, setShowOtpView] = React.useState(false);

  const sendCancelRequestOtp = async () => {
    const response = await api.SendCancelSubsOtp();
    if (response.status === 1) {
      setShowOtpView(true)
      // alert('Otp sent successfully')
      toast.success(response.message);

      // logMessage('Otp sent successfully', "alert");
    } else if (response.status === 2) {
      setShowOtpView(true)
      toast.success(response.message);
      // logMessage(response.message, "alert");
    }
    else {
      // alert(response.message)
      toast.error(response.message); 
    }
  };
  const VerifyCancelRequestOtp = async () => {
    const response = await api.VerifyCancelSubsOtp({ otp });
    if (response.status === 1) {
      setFinalCancelConfirm(true)
    } else {
      // alert(response.message)
      // logMessage(response.message, "alert");
      toast.error(response.message);

    }
  };
  const cancelSub = async () => {
    try {
      showButtonLoading(true);
      const data = {
        sub_id: subId,
      };
      const response = await api.cancelSubscription(data);
      const apiResponse = new ApiResponse(response.status, response.message);
      if (apiResponse.status === 1) {
        window.location.reload();
      } else {
        logMessage(apiResponse.message, "alert");
      }
    } catch (error) {
      logMessage(error);
    } finally {
      showButtonLoading(false);
    }
  };
  //============================ Cancel Subscription =================================˝
  const getProfileData = async () => {
    try {
      startLoading();
      const response = await api.getProfile();
      const apiResponse = new ApiResponse(response.status, response.message);
      if (apiResponse.status === 1) {
        const signUpResponse = new UserData(response.data);

        localStorage.setItem("user_data", JSON.stringify(signUpResponse.data));
        localStorage.setItem("user_email", signUpResponse.email);
        localStorage.setItem("user_name", signUpResponse.name);
        localStorage.setItem("profile_picture", signUpResponse.profile_picture);
        logMessage("Update runs");
        logMessage(signUpResponse.profile_picture);

        // setTimeout(() => {
        setName(signUpResponse.name);
        setEditFormData({
          image: signUpResponse.profile_picture,
          name: signUpResponse.name,
        });
      
        setProfile(signUpResponse.profile_picture);
        setIsVip(response.data.is_vip);

        localStorage.setItem('isVip', response.data.is_vip);

        if(response.data.is_vip == "false"){
          console.log("insideisvip");
          getSubDetail();
        }else{
          stopLoading();
          console.log("outsidevip");
        }

        // }, 1000);
      } else {
        logMessage(apiResponse.message, "alert");
      }
    } catch (error) {
      logMessage(error);
    }
  };
  const getSubDetail = async () => {
    try {
      startLoading();
      const response = await api.getSubscriptionDetail();
      const apiResponse = new ApiResponse(response.status, response.message);
      if (apiResponse.status === 1) {
        const subModel = new SubModel(response.data); 
        if (subModel.isSubscribed == "true") {
          setUserType("Premium");
          localStorage.setItem('isVerified', true);
          setInterval(subModel.interval);
          setIntervalCount(subModel.intervalCount);
          setAmount(subModel.amount);
          setSubId(subModel.sub_id);
          setRenewalAmount(subModel.renewalAmount);
          setCurrencySymbol(subModel.currencySymbol);
          setPurchasedOn(subModel.purchased_on);
          setExpiryTime(subModel.expiry_time);
          setCurrency(subModel.currency);
          setStatus(subModel.status);
          setSubscriptionPurchasedFrom(subModel.subscriptionPurchasedFrom);
        } else {
          localStorage.setItem('isVerified', false);
          setUserType("Basic");
        }
        stopLoading();
        // }, 1000);
      } else {
        logMessage(apiResponse.message, "alert");
      }
    } catch (error) {
      logMessage(error);
    } finally {
      stopLoading();
    }
  };

  const getProgressData = async () => {
    try {
      const normalizeProgressData = (data = {}) => {
        const tier = data?.current_tier || {};
        const streak = data?.streak;
        const currentLevel = Number(data?.current_level || 1);
        const totalXp = Number(data?.total_xp || 0);
        const xpRequired =
          data?.xp_required_for_completion != null && data.xp_required_for_completion !== ""
            ? Number(data.xp_required_for_completion)
            : null;
        const currentXpProg =
          data?.current_xp != null && data.current_xp !== "" ? Number(data.current_xp) : null;
        const pointsAway =
          xpRequired != null && currentXpProg != null
            ? Math.max(0, xpRequired - currentXpProg)
            : xpRequired != null
              ? Math.max(0, xpRequired - totalXp)
              : 0;

        return {
          current_level: currentLevel,
          level_title: data?.level_title || `Level ${currentLevel}`,
          total_xp: totalXp,
          current_xp: currentXpProg,
          xp_required_for_completion: xpRequired,
          points_away_text:
            data?.points_away_text ||
            (xpRequired != null
              ? `Just ${pointsAway} Points away from next level!`
              : "You reached the highest active level!"),
          current_tier: {
            name: tier.name || "",
            key: (tier.key || "bronze").toLowerCase(),
            icon: tier.icon || "",
          },
          streak: streak
            ? {
                summary_text:
                  streak?.summary_text ||
                  `${Number(streak?.current_streak_days ?? 0)} day painting streaks`,
                grace_text:
                  streak?.grace_text ||
                  (streak?.grace_available
                    ? "1 grace day available"
                    : "No grace day available"),
              }
            : null,
          badge_count: Number(data?.badge_count || 0),
          reward_count: Number(data?.reward_count || 0),
        };
      };

      const response = await api.getProgress();
      if (response?.status === 1 && response?.data) {
        setProgressData(normalizeProgressData(response.data));
      } else {
        setProgressData(null);
      }
    } catch (error) {
      logMessage(error);
      setProgressData(null);
    }
  };
  useEffect(() => {
    // console.log("calledgain")
    getProfileData();
    getProgressData();
    const queryParams = new URLSearchParams(location.search);
    const action = queryParams.get("action");

    // Check if action is 'support'
    if (action === "support") {
      setType("support");
    }
    // getProductsDetail();
  }, []);

  const uploadImageClick = (e) => {
    e.preventDefault();
    logMessage("clicked");
    document.getElementById("imageUploadInput").click();
  };

  return (
    <div className="full_page_inner">
      <Header />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <div
        className="dashboard_container profile_container"
        style={{ backgroundImage: `url(${imagePaths.profile_back})` }}
      >
        <div className="home_container profile_outer_container">
          {showPopup && (
            <div className="popup-overlay">
              <div className="popup">
                <h2>Delete Account</h2>
                <p>Are you sure you want to delete account</p>
                <div className="warning">
                  <div className="warningtextbox">
                    <p className="warningtext">
                      <IoIosWarning /> Warning
                    </p>
                  </div>

                  <p>
                    By deleting the account you will loose all your projects
                    data and media
                  </p>
                </div>
                <button className="delete-button" onClick={deleteAccount}>
                  Yes, Delete Account
                </button>
                <button
                  className="cancel-button canceldelacc"
                  onClick={togglePopup}
                >
                  Cancel
                </button>
              </div>
            </div>
          )}
           {showIosPopUp && (
            <div className="popup-overlay">
              <div className="popup">
                <h2>Cancel Subscription</h2>
                <p>You purchased this subscription from an iOS device.</p>
                <div className="warning">
                  <div className="warningtextbox">
                    <p className="warningtext">
                      <IoIosWarning /> Notice
                    </p>
                  </div>
                  <p>
                    To cancel your subscription, please use your Apple device and go to
                    Settings &gt; Apple ID &gt; Subscriptions.
                  </p>
                </div>
                <button
                  className="cancel-button canceldelacc"
                  onClick={toggleIosPopup}
                >
                  Close
                </button>
              </div>
            </div>
          )}

          {showVerifyPopUp && (
            <div className="popup-overlay">
              <div className="popup">
                <h2>Verify Payment</h2>
                <p>Close the window and click on continue to verify payment ?  </p>
                <button className="delete-button" onClick={refreshPage}>
                  Yes, Verify Payment
                </button>
              </div>
            </div>
          )}
          {showSubPopUp && (

            finalCancelConfirm
              ?
              < div className="popup-overlay">
                <div className="popup subPopCancellation"
                style={{
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundImage: `url(${imagePaths.backgroundStars})`,
                }}
                >
                <div className="innerDetails" 
                        >
                        <img alt="crownImage" className="crownImage" src={imagePaths.crown}></img>
                    <h2 style={{margin: 'auto'}}>Downgrade Subscription Plan</h2>
                    </div>
                <div className="subwarning">
                    {/* <div className="warningtextbox">
                      <p className="warningtext">
                        <IoIosWarning /> Warning
                      </p>
                    </div> */}
                    <p 
                    style={{color:"#E84343",
                      fontSize:"12px"

                    }}  
                    >
                    Are you sure you want to downgrade to basic plan?
                    </p>
                  </div>
                  <button className="delete-button" style={{background:"#BE2424", border:"none"}} onClick={cancelSub}>
                    {buttonLoading ? "Cancelling..." : "Yes, Downgrade"}
                  </button>
                  <button
                    className="cancel-button canceldelacc"
                    onClick={() => setFinalCancelConfirm(false)}
                  >
                    Not Now
                  </button>
                </div>
              </div>
              :
              showOtpView
                ?
                <div className="popup-overlay">
                  <div className="popup subPopCancellation otherCancellation">
                  <p onClick={() => { setShowSubPopUp(!showSubPopUp); setShowOtpView(false) }} style={{textAlign:'right', color:"#552F83", fontSize:"13px", cursor:"pointer"}}>Close</p>
                    <img style={{width:'130px'}} src={imagePaths.diamond_img}></img>
                    <p className="otpverificationtitle">OTP Verification</p>
                    <p className="otpverificationdescription">Enter the verification code we just sent on your email address.</p>
                    {/* <div className="warning">
                      <div className="warningtextbox">
                        <p className="warningtext">
                          <IoIosWarning /> Warning
                        </p>
                      </div>

                      <p>
                        Your subscription will be cancelled, but you’ll continue to
                        enjoy full access and benefits until it expires.
                      </p>
                    </div> */}
                    <div style={styles.otpContainer}>
                      {otp.map((digit, index) => (
                        <input
                          key={index}
                          type="text"
                          inputMode="numeric"
                          maxLength="1"
                          value={digit}
                          onChange={(e) => handleChangeCancel(e, index)}
                          onKeyDown={(e) => handleBackspace(e, index)}
                          style={styles.otpInput}
                          id={`otp-input-${index}`}
                        />
                      ))}
                    </div>
                    {/* <input type="number" value={otp} onChange={(e) => setOtp(e.target.value)} className="inputAndIconSubs" /> */}
                   
                    <button
                    style={{marginBottom:"15px"}}
                      className="delete-button"
                      onClick={VerifyCancelRequestOtp}
                    >
                      Verify
                    </button>
                    {/* <button className="cancel-button canceldelacc" onClick={VerifyCancelRequestOtp}>
                      {buttonLoading ? "Verifying..." : "Submit"}
                    </button> */}
                    <p onClick={sendCancelRequestOtp} className="resendcode">Didn't received code? <span className="resendcodetext">{buttonLoading ? "Sending" : "Resend"}</span></p>
                  </div>
                </div>
                :
                < div className="popup-overlay">
                  <div className="popup subPopCancellation"
                   style={{
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat",
                    backgroundImage: `url(${imagePaths.backgroundStars})`,
                  }}
                  >
                     <div className="innerDetails" 
                        >
                        <img className="crownImage" src={imagePaths.crown}></img>
                    <h2 style={{margin: 'auto'}}>Downgrade Subscription Plan</h2>
                    </div>
                    {/* <p>Are you sure you want to cancel subscription</p> */}
                    <div className="warning subwarning">
                      <div className="warningtextbox">
                        <p className="warningtext">
                          {/* <IoIosWarning /> */}
                          {/* Warning */}
                        </p>
                      </div>
                      <p className="cancelTitle" style={{ margin: "0.5rem 0", color: '#E84343', fontWeight:'600'}}>Canceling your subscription will result in losing access to the following features:</p>
                    </div>
                    <ul className="benefitsList">
                      <li>Unlimited project creation: Only your first 5 projects will remain visible. Any additional projects will be saved but will only become accessible again if you upgrade.</li>
                      <li>The Leaderboard section and eligibility to win prizes.</li>
                      <li>Desktop version access: You will only be able to use the mobile version of the app.</li>
                      <li>Exclusive member discounts.</li>
                      <li>Priority support.</li>
                    </ul>
                    <button className="delete-button canceldowngrade" onClick={() => setShowSubPopUp(!showSubPopUp)}>
                        Cancel Downgrade                    
                        </button>
                    <button className="delete-button cancelSubClass" 
                    onClick={() => {
                        if (subscriptionPurchasedFrom === "inapppurchase") {
                          setShowSubPopUp(false); // optional: or !showSubPopUp if toggle needed
                          setShowIosPopUp(true);
                        } else {
                          sendCancelRequestOtp();
                        }
                      }}
                    >
                      {buttonLoading ? "Cancelling..." : "Downgrade Subscription"}
                    </button>
                  </div>
                </div>

          )}

          <div className={`profile_inner_container ${isProgressLayout ? "progress_layout" : ""}`}>
            <div className={`left_profile_container ${isProgressLayout ? "progress_left_sticky" : ""}`}>
              <div onClick={uploadImageClick} className="image box">
                <img src={profile || imagePaths.demo_profile} alt="Profile" />
                <div className="camera-icon">
                  <FaCamera />
                </div>
              </div>
              <input
                style={{ display: "none" }}
                type="file"
                id="imageUploadInput"
                accept="image/png, image/jpeg"
                onChange={handleFileChange}
              />
              <p
                style={{ fontSize: "22px", fontWeight: "500" }}
                className="name userprofilename"
              >
                {name}
              </p>
              <p
                style={{ fontSize: "16px" }}
                className="email userprofileemail"
              >
                {email}
              </p>
              {/* { isVip == "true" && (
              <div className="subDetailBox"
              style={{
                padding: "1px 1px 1px 1px" ,
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundImage: `url(${imagePaths.backgroundStars})`,
              }}
              >
                <h1>hello</h1>
                </div>
              )} */}

              <div className="subDetailBox"
              style={{
                display: isVip == "true" ? "none" : "block",
                padding: "1px 1px 1px 1px" ,
                // backgroundSize: "contain",
                // backgroundRepeat: "no-repeat",
                backgroundImage: `url(${imagePaths.backgroundStars})`,
              }}
              >

                {/* <p
                  style={{ fontSize: "16px", fontWeight: "500" }}
                  className="email userprofileemail"
                >
                  {" "}
                </p> */}
                {/* //here check */}
                {userType !== "" && isVip == "false" && (
                  <div>
                    {userType === "Premium" ? (
                      <div style={{ padding: "1px 0px 0px 0px" }}>
                          <div className="innerDetails" 
                        >
                        <img alt="crownImage" className="crownImage" src={imagePaths.crown}></img>
                        <p className="email userprofileemail userTypePara"
                          style={{ fontSize: "14px", fontWeight: "600",
                        }}
                        >
                           {interval === "MONTH" ? "Premium - Monthly" : "Premium - Annual"}
                        </p>
                        </div> 
                        {status === "ACTIVE" ? (
                          <div>
                           <div className="innerTiles">
                            
                        <p
                          className="email userprofileemail"
                          style={{
                            fontSize: "14px",
                          }}
                        >
                          Current Status:
                        </p>
                        <div className="innerDetails" 
                        >
                        <img alt="tickImage" className="tickImage" src={imagePaths.tick}></img>
                        <p
                         className="email userprofileemail rightSideSubText"
                        style={{
                          fontSize: "14px",
                          // textAlign: "center",
                        }}>
                        {status}
                        </p>
                        </div>
                        </div>
                        <div className="innerTiles">
                        <p
                          className="email userprofileemail"
                          style={{
                            fontSize: "14px",
                          }}
                        >
                          Renewal Date:
                        </p>
                        <p
                         className="email userprofileemail rightSideSubText"
                        style={{
                          fontSize: "14px",
                          // textAlign: "center",
                        }}>
                        {expiryTime}
                        </p>
                        </div>
                        <div className="innerTiles lastSubTile">
                        <p
                          className="email userprofileemail"
                          style={{
                            fontSize: "14px",
                          }}
                        >
                          Renewal Price:
                        </p>
                        <p
                         className="email userprofileemail rightSideSubText"
                        style={{
                          fontSize: "14px",
                          // textAlign: "center",
                        }}>
                         {currencySymbol}{parseFloat(renewalAmount)}
                        </p>
                        </div>
                          </div>
                        ) : (
                          <div>
                          <div className="innerTiles">
                        <p
                          className="email userprofileemail"
                          style={{
                            fontSize: "14px",
                          }}
                        >
                          Current Status:
                        </p>
                        <p
                         className="email userprofileemail rightSideSubText warningDate"
                        style={{
                          fontSize: "14px",
                          // textAlign: "center",
                        }}>
                        {status}
                        </p>
                        </div>
                        <div className="innerTiles">
                        <p
                          className="email userprofileemail"
                          style={{
                            fontSize: "14px",
                          }}
                        >
                          Valid Up To:
                        </p>
                        <p
                         className="email userprofileemail rightSideSubText warningDate"
                        style={{
                          fontSize: "14px",
                          // textAlign: "center",
                        }}>
                        {expiryTime}
                        </p>
                        </div>
                        <div className="innerTiles lastSubTile">
                        <p
                          className="email userprofileemail"
                          style={{
                            fontSize: "14px",
                          }}
                        >
                          Renewal Price:
                        </p>
                        <p
                         className="email userprofileemail rightSideSubText"
                        style={{
                          fontSize: "14px",
                          // textAlign: "center",
                        }}>
                        {currencySymbol}{parseFloat(renewalAmount)}
                        </p>
                        </div>
                        </div>
                        )}
                      </div>
                    ) : (
                      <div style={{ padding: "1px 1px 1px 1px" ,
                        backgroundSize: "contain",
                        backgroundRepeat: "no-repeat",
                        backgroundImage: `url(${imagePaths.backgroundStars})`,
                      }}>
                        <div className="innerDetails" 
                        style={{marginBottom:"2px"}}
                        >
                        <img alt="crownImage" className="crownImage" src={imagePaths.crown}></img>
                        <p className="email userprofileemail userTypePara"
                          style={{ fontSize: "14px", fontWeight: "600",
                        }}
                        >
                          {userType}
                        </p>
                        </div> 
                        <button
                          style={{ marginBottom: "10px" }}
                          onClick={openSubscribeBox}
                          className="addProject"
                        >
                         Upgrade to Premium
                        </button>
                      </div>
                    )}
                  </div>
                )}
                
              </div>

              {status === "ACTIVE" && isVip == "false" && (
                <button
                  style={{ margin: "20px 10px 10px 10px", fontWeight:'600 !important'}}
                  className="addProject cancelSubClass"
                  onClick={() => {
                    // if (subscriptionPurchasedFrom === "inapppurchase") {
                    //   // setShowIosPopUp(true);
                    //   setShowSubPopUp(!showSubPopUp);
                    // } else {
                      setShowSubPopUp(!showSubPopUp);
                    // }
                  }}
                >
                  Cancel Plan
                </button>
              )}

              {isVip === "true" && (
                
                <div
                className="subDetailBox"
                  style={{
                    padding: "1px",
                    // backgroundSize: "contain",
                    // backgroundRepeat: "no-repeat",
                    backgroundImage: `url(${imagePaths.backgroundStars})`,
                  }}
                >
                  <div className="innerDetails" style={{ marginBottom: "2px" }}>
                    <img
                      alt="crownImage"
                      className="crownImage"
                      src={imagePaths.crown}
                    />
                    <p
                      className="email userprofileemail userTypePara"
                      style={{ fontSize: "14px", fontWeight: "600" }}
                    >
                      VIP Membership
                    </p>
                  </div>

                  <div>
                    <div className="innerTiles">
                      <p className="email userprofileemail" style={{ fontSize: "14px" }}>
                        Current Status:
                      </p>
                      <div className="innerDetails">
                        <img
                          alt="tickImage"
                          className="tickImage"
                          src={imagePaths.tick}
                        />
                        <p
                          className="email userprofileemail rightSideSubText"
                          style={{ fontSize: "14px" }}
                        >
                          Active
                        </p>
                      </div>
                    </div>
                    <div className="innerTiles">
                        <p
                          className="email userprofileemail"
                          style={{
                            fontSize: "14px",
                          }}
                        >
                          Valid Up To:
                        </p>
                        <p
                         className="email userprofileemail rightSideSubText"
                        style={{
                          fontSize: "14px",
                          // textAlign: "center",
                        }}>
                        Lifetime
                        </p>
                        </div>
                  </div>
                </div>
              )}


            </div>

            <div
              className={`right_profile_container ${isProgressLayout ? "progress_right_scroll" : ""} ${
                isPointsDashboardPage || isLevelJourneyPage || isStreaksJourneyPage || isBadgesPanelPage || isRewardPanelPage || isRewardDetailPage ? "points_dashboard_host" : ""
              }`}
            >
              { isRewardDetailPage ? (
                <RewardDetailPanel
                  startLoading={startLoading}
                  stopLoading={stopLoading}
                />
              ) : isRewardPanelPage ? (
                <RewardsPanel 
                  startLoading={startLoading}
                  stopLoading={stopLoading}
                />
              ) : isBadgesPanelPage ? (
                <BadgesPanel 
                  startLoading={startLoading}
                  stopLoading={stopLoading}
                />
              ) : isStreaksJourneyPage ? (
                <StreaksJourneyPanel 
                  startLoading={startLoading}
                  stopLoading={stopLoading}
                />
              ) :
              isPointsDashboardPage ? (
                <PointsDashboardPanel
                  startLoading={startLoading}
                  stopLoading={stopLoading}
                />
              ) : isLevelJourneyPage ? (
                <LevelJourneyPanel startLoading={startLoading} stopLoading={stopLoading} />
              ) : isProgressPage ? (
                <YourProgressPanel
                  progressData={progressData}
                  onProfileClick={() => navigate(paths.MY_PROFILE)}
                  onPointsDashboardClick={() => navigate(paths.POINTS_DASHBOARD)}
                  onLevelJourneyClick={() => navigate(paths.LEVEL_JOURNEY)}
                  onLeaderboardClick={() => navigate(paths.LEADERBOARD)}
                  onBadgesClick={()=>navigate(paths.BADGES_PANEL)}
                  onRewardsClick={()=>navigate(paths.REWARD_PANEL)}
                />
              ) : (
                <>
                  <div className="tabs_profile">
                    <div
                      onClick={() => handleChange("personal")}
                      className={type === "personal" ? "tab active" : "tab"}
                    >
                      Personal Information
                    </div>
                    <div
                      onClick={() => handleChange("settings")}
                      className={type === "settings" ? "tab active" : "tab"}
                    >
                      Settings
                    </div>
                  </div>
                  <div className="info_content">
                    {getTypeComponent(type)}
                  </div>
                  <div className="px-20 pb-6 w-[57%] cursor-pointer" onClick={() => navigate(paths.YOUR_PROGRESS)}>
                    <div className="border-t bg-[#848484] mb-6 h-px" />
                    <div className="w-full h-24 rounded-2xl bg-[linear-gradient(273.47deg,#FFFFFF_-14.44%,#EEECFF_54.56%)] shadow-sm flex items-center justify-start gap-5 px-6">
                      <div className=" rounded-xl h-12 w-12 bg-white flex items-center justify-center gap-10">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M21.9199 6.62C21.8185 6.37565 21.6243 6.18147 21.3799 6.08C21.2597 6.02876 21.1306 6.00158 20.9999 6H15.9999C15.7347 6 15.4804 6.10536 15.2928 6.29289C15.1053 6.48043 14.9999 6.73478 14.9999 7C14.9999 7.26522 15.1053 7.51957 15.2928 7.70711C15.4804 7.89464 15.7347 8 15.9999 8H18.5899L12.9999 13.59L9.70994 10.29C9.61698 10.1963 9.50637 10.1219 9.38452 10.0711C9.26266 10.0203 9.13195 9.9942 8.99994 9.9942C8.86793 9.9942 8.73722 10.0203 8.61536 10.0711C8.4935 10.1219 8.3829 10.1963 8.28994 10.29L2.28994 16.29C2.19621 16.383 2.12182 16.4936 2.07105 16.6154C2.02028 16.7373 1.99414 16.868 1.99414 17C1.99414 17.132 2.02028 17.2627 2.07105 17.3846C2.12182 17.5064 2.19621 17.617 2.28994 17.71C2.3829 17.8037 2.4935 17.8781 2.61536 17.9289C2.73722 17.9797 2.86793 18.0058 2.99994 18.0058C3.13195 18.0058 3.26266 17.9797 3.38452 17.9289C3.50637 17.8781 3.61698 17.8037 3.70994 17.71L8.99994 12.41L12.2899 15.71C12.3829 15.8037 12.4935 15.8781 12.6154 15.9289C12.7372 15.9797 12.8679 16.0058 12.9999 16.0058C13.132 16.0058 13.2627 15.9797 13.3845 15.9289C13.5064 15.8781 13.617 15.8037 13.7099 15.71L19.9999 9.41V12C19.9999 12.2652 20.1053 12.5196 20.2928 12.7071C20.4804 12.8946 20.7347 13 20.9999 13C21.2652 13 21.5195 12.8946 21.707 12.7071C21.8946 12.5196 21.9999 12.2652 21.9999 12V7C21.9984 6.86932 21.9712 6.74022 21.9199 6.62Z" fill="#552F83"/>
                        </svg>
                      </div>
                      <div className=" flex justify-between items-center w-full">
                        <div>
                          <h1 className=" primary-text font-semibold leading-3 text-xl">Your Progress</h1>
                          <h1 className=" text-[#323232] font-light leading-3 text-sm">View levels, badges and streaks </h1>
                        </div>
                        <MdKeyboardArrowRight className="w-5 h-5 text-[#323232]" />
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div >
  );
};

export default MyProfile;
